import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import AppHeader from '../components/common/AppHeader'
import PhotoCompare from '../components/photoTools/PhotoCompare'

const PhotoComparePage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()

  const handleBackClick = () => {
    navigate('/photo-tools')
  }

  return (
    <>
      <AppHeader
        title="Photo Compare"
        username={user?.username}
        showAdminButton={isAdmin}
        showBackButton
        onBackClick={handleBackClick}
        onLogout={logout}
      />

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Photo Compare
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Porównaj dwa zdjęcia z efektem odsłaniania kurtyny
          </Typography>
        </Box>

        <PhotoCompare />
      </Container>
    </>
  )
}

export default PhotoComparePage
